import { NgClass } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppLoadingScreenComponent } from './app-loading-screen.component';
import { AppLoadingService } from './app-loading.service';
import { AppNewReleaseAnnouncementCardComponent } from './app-new-release-announcement-card.component';
import * as fromAuth from './auth/store/auth.reducer';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ConfirmDialogService } from './confirm-dialog/confirm-dialog.service';
import * as fromFeatureFlags from './feature-flags';
import * as fromLayout from './layout';
import { appFeature, AppState } from './store/app.reducer';

@Component({
  imports: [
    RouterModule,
    AppNewReleaseAnnouncementCardComponent,
    AppLoadingScreenComponent,
    ConfirmDialogComponent,
    NgClass,
    fromFeatureFlags.FeatureFlagsDirective,
  ],
  selector: 'squadbox-root',
  template: `
    @if (isFirstNavigationComplete()) {
      <router-outlet></router-outlet>
      @let apiVersion = apiReleaseVersionWithoutPrefix();
      @if (apiVersion && isAppNewReleaseAnnouncementVisible()) {
        <squadbox-app-new-release-announcement-card
          squadboxFeatureFlag="ff-new-release-announcement"
          [apiReleaseVersion]="apiVersion"
          class="fixed z-50 bottom-4"
          [ngClass]="{
            'w-[90%] left-1/2 -translate-x-1/2': isMobile(),
            'left-5': !isMobile(),
          }"
        ></squadbox-app-new-release-announcement-card>
      }
    } @else {
      <squadbox-app-loading-screen />
    }

    @if (confirmDialog.options(); as options) {
      <squadbox-confirm-dialog
        [options]="options"
        (choose)="confirmDialog.respond($event)"
      />
    }
  `,
  styles: [``],
})
export class AppComponent {
  private readonly appStore = inject<Store<AppState>>(Store);
  private readonly layoutStore = inject<Store<fromLayout.LayoutState>>(Store);
  private readonly authStore = inject<Store<fromAuth.AuthState>>(Store);
  private readonly appLoadingService = inject(AppLoadingService);
  protected readonly confirmDialog = inject(ConfirmDialogService);

  public readonly isFirstNavigationComplete =
    this.appLoadingService.isFirstNavigationComplete;

  private readonly user = this.authStore.selectSignal(
    fromAuth.authFeature.selectUser,
  );
  private readonly isApiReleaseVersionDifferentThanUiReleaseVersion =
    this.appStore.selectSignal(
      appFeature.isApiReleaseVersionDifferentThanUiReleaseVersion,
    );

  public readonly isMobile = this.layoutStore.selectSignal(
    fromLayout.layoutFeature.selectIsMobile,
  );
  public readonly isAppNewReleaseAnnouncementVisible = computed(
    () =>
      this.user() !== null &&
      this.isApiReleaseVersionDifferentThanUiReleaseVersion(),
  );
  public readonly apiReleaseVersionWithoutPrefix = this.appStore.selectSignal(
    appFeature.selectApiReleaseVersionWithoutPrefix,
  );
}
